import { ApiAccess, CartService } from "../services/ApiAcccess.service";
import { getLocaleConfig } from "../utils/locale.utils";
import { StorageUtils } from "../utils/storage.utils";
import { processCart, scanProducts } from "./product.events";
import { nvstore } from "../state/store";
import { actionTypes } from "../state/actions/cartActions";
import { ProductContext } from "./product.context";

export const ProductModule = {
    setProducts: (cartKey: string, DROptions: any, cartEnabledLocales: string[], isHeadless: boolean) => {
        var storedState = StorageUtils.getCookie(cartKey);
        const nvLocale: string = DROptions.locale;
        if (storedState === undefined || storedState == "") {
            storedState = { "cart": [], "lastAction": null };
            console.log('cartKey==>', cartKey);
            StorageUtils.setCookie(cartKey, JSON.stringify(storedState));
        }
        var now = new Date();
        var hasExpired = function (now, expireDate) {
            return (expireDate < now);
        }
        if (storedState != null) {
            var parsedState;
            if (typeof storedState === 'string') {
                parsedState = JSON.parse(storedState);
            } else {
                parsedState = storedState;
            }
            var obj = parsedState?.cart;
            var objLength = obj.length;
            if (objLength) {
                for (var key = objLength - 1; key >= 0; key--) {
                    var expired = Date.parse(obj[key]["expires"]);
                    var region = obj[key]['locale'];
                    if (hasExpired(now, expired)) {
                        obj.splice(key, 1);
                    } else if (region.toLowerCase().replace("_", "-") !== nvLocale.toLowerCase().replace("_", "-")) {
                        obj.splice(key, 1);
                    }
                }
            }
            let uniqueCategories, activeTab;
            var initialCartState = parsedState?.cart;
            var bcCartID = null;
            bcCartID = StorageUtils.getCookie('bcCartID');
            console.log('checkout==>', StorageUtils.getCookie('checkout'));
            
            // Check if cartProductsList is already populated
            const existingProductsList = ProductContext.getCartProductsList();
            const shouldScanProducts = !existingProductsList || existingProductsList.length === 0;
            
            if (shouldScanProducts) {
                console.log('📦 cartProductsList is empty, scanning products...');
            } else {
                console.log('✅ cartProductsList already populated with', existingProductsList.length, 'products, skipping scan');
            }
            
            // Create a promise that either scans products or resolves immediately with existing data
            const productsPromise = shouldScanProducts 
                ? scanProducts(DROptions, isHeadless)
                : Promise.resolve(existingProductsList);
            
            productsPromise.then(function (productListRes) {
                console.log('✅ Products available ==>', productListRes);
                // console.log('Replay sessionStorage.getItem(checkoutClicked)', StorageUtils.getSessionItem('checkoutClicked'));
                // if (JSON.parse(sessionStorage.getItem('checkoutClicked')) && cartEnabledLocales.includes(nvLocale)) {
                //     console.log('state', StorageUtils.getCookie(cartKey));
                //     var state = parsedState;
                //     var cart = state.cart.filter((item) => item.category === 'nvidia');
                //     var partnerCart = state.cart.filter((item) => item.category === 'partner');
                //     var activeTabCategory = state['activeTab'] ? state['activeTab'] : sessionStorage.getItem('category');
                //     console.log('Checkout==>', activeTabCategory, state.activeTab);
                //     if (sessionStorage.getItem('directBuy')) {
                //         var directBuy = sessionStorage.getItem('directBuy');
                //         // processCart(JSON.parse(directBuy), 'nvidia', true, S_ID);
                //         CartService.addLineItems(JSON.parse(directBuy))
                //     } else {
                //         if (activeTabCategory === 'nvidia') {
                //             processCart(state.cart, 'nvidia', true);
                //         } else {
                //             processCart(state.cart, 'partner', true)
                //         }
                //     }
                // }

                const productList = productListRes.map(p => {
                    return {
                        pid: p.id,
                        price: p.unitPrice || 0,
                    }
                })

                if (StorageUtils.getCookie('checkout')) {
                    console.log('checkout==>', JSON.parse(StorageUtils.getCookie('checkout')));
                    CartService.getCartData(nvLocale).then(function (res) {
                        console.log('✅ getCartData RESOLVED successfully ==>', res);
                        console.log('cookieData==>',cartKey, StorageUtils.getCookie(cartKey));
                        
                        const currentState = nvstore.getState();
                        
                        // Handle empty cart response: { "cartItems": {} }
                        if (res && res.cartItems && (!res.cartItems.cartItem || (Array.isArray(res.cartItems.cartItem) && res.cartItems.cartItem.length === 0))) {
                            console.log('🛒 Empty cart response detected, clearing cart');
                            
                            // Set cart to empty array
                            nvstore.dispatch({
                                type: actionTypes.SET_CART,
                                cart: [],
                                lastAction: null
                            });
                            
                            // Update cookie to persist empty cart
                            StorageUtils.setCookie(cartKey, JSON.stringify({
                                cart: [],
                                lastAction: null
                            }));
                            
                            // Delete checkout cookie since cart is empty
                            StorageUtils.deleteCookie('checkout');
                            
                            console.log('✅ Cart cleared due to empty API response, checkout cookie deleted');
                            return;
                        }
                        
                        // Map API response to Redux cart format
                        if (res && res.cartItems && res.cartItems.cartItem && Array.isArray(res.cartItems.cartItem) && res.cartItems.cartItem.length > 0) {
                            const existingCart = currentState.cart || [];
                            
                            // Helper function to extract numeric values from formatted price strings
                            const extractPrice = (formattedPrice: string): number => {
                                if (!formattedPrice) return 0;
                                return parseFloat(formattedPrice.replace(/[^0-9.-]/g, '')) || 0;
                            };
                            
                            // Map API cart items to CartProduct format
                            const mappedCartItems = res.cartItems.cartItem.map(function (apiItem: any) {
                                const product = apiItem.product || {};
                                const pricing = apiItem.pricing || {};
                                const productId = String(product.alm_id || '');
                                
                                // Extract numeric values from formatted strings (remove $, commas)
                                const listPriceWithQuantity = (productList.find(p => p.pid === productId)?.price * apiItem.quantity) || extractPrice(pricing.formattedListPriceWithQuantity || pricing.formattedSalePriceWithQuantity || '0');
                                const salePriceWithQuantity = (productList.find(p => p.pid === productId)?.price * apiItem.quantity) || extractPrice(pricing.formattedSalePriceWithQuantity || '0');
                                const listPrice = productList.find(p => p.pid === productId)?.price || extractPrice(pricing.formattedListPrice || '0');
                                
                                // Calculate unit price from listPriceWithQuantity / quantity
                                const unitPrice = productList.find(p => p.pid === productId)?.price || (apiItem.quantity > 0 ? listPriceWithQuantity / apiItem.quantity : listPrice);
                                
                                // Get category from existing cart state when product id matches; otherwise default to 'partner'
                                const matchedCartItem = existingCart.find((item: any) => String(item.id) === productId);
                                const category = (matchedCartItem && matchedCartItem.category) ? matchedCartItem.category : 'partner';
                                
                                // Create expire date (2 days from now, matching reducer logic)
                                const expireDate = new Date();
                                expireDate.setDate(expireDate.getDate() + 2);
                                
                                return {
                                    id: productId,
                                    sku: product.sku || productId,
                                    name: product.displayName || product.name || '',
                                    isQuantity: true,
                                    quantity: apiItem.quantity || 1,
                                    activeTab: category,
                                    category: category,
                                    productType: (product.productType || 'PHYSICAL').toUpperCase(),
                                    listPrice: listPriceWithQuantity,
                                    unitPrice: unitPrice,
                                    pricing: {
                                        listPriceWithQuantity: listPriceWithQuantity,
                                        salePriceWithQuantity: salePriceWithQuantity || listPriceWithQuantity,
                                        unitPrice: unitPrice
                                    },
                                    totalPrice: listPriceWithQuantity.toFixed(2),
                                    productIsInStock: true, // Default to true, adjust if API provides this
                                    productIsAllowsBackorders: false, // Default to false, adjust if API provides this
                                    expires: expireDate,
                                    locale: nvLocale,
                                    minimumQuantity: product.minimumQuantity || 1,
                                    limitPerCustomer: product.maximumQuantity || null,
                                    availableQuantity: product.maximumQuantity || null,
                                    promo: product.customAttributes?.attribute || []
                                };
                            });
                            
                            // Merge with existing cart items
                            // Strategy: Replace items that exist in API response with API data (including quantity)
                            // Preserve items that don't exist in API response
                            const mergedCart: any[] = [];
                            const apiItemIds = new Set(mappedCartItems.map((item: any) => String(item.id)));
                            
                            // First, add all API items (these will replace any existing items with same id)
                            mappedCartItems.forEach(function (mappedItem: any) {
                                // Ensure quantity is explicitly set from API (parse as integer to avoid type issues)
                                mappedItem.quantity = parseInt(String(mappedItem.quantity), 10) || 1;
                                mergedCart.push(mappedItem);
                            });
                            
                            // Then, add existing items that are NOT in the API response
                            existingCart.forEach(function (existingItem: any) {
                                const existingItemId = String(existingItem.id);
                                if (!apiItemIds.has(existingItemId)) {
                                    // This item is not in API response, preserve it
                                    mergedCart.push(existingItem);
                                }
                                // If item exists in API response, it's already been added above, so skip it
                            });
                            
                            // Dispatch SET_CART action to update Redux state
                            // Set lastAction to null since this is an API restore, not a user action
                            nvstore.dispatch({
                                type: actionTypes.SET_CART,
                                cart: mergedCart,
                                lastAction: null  // Prevent cart from auto-opening after API sync
                            });
                            
                            // Update cookie to persist the merged cart
                            // Set lastAction to null to match Redux state (API restore, not user action)
                            StorageUtils.setCookie(cartKey, JSON.stringify({
                                cart: mergedCart,
                                lastAction: null  // Prevent cart from auto-opening on restoration
                            }));
                            
                            console.log('✅ Mapped and merged cart items:', {
                                apiItems: mappedCartItems.length,
                                existingItems: existingCart.length,
                                totalItems: mergedCart.length
                            });
                        } else {
                            console.warn('⚠️ Invalid API response structure:', res);
                            // Delete checkout cookie if response structure is invalid
                            StorageUtils.deleteCookie('checkout');
                            console.log('✅ Checkout cookie deleted due to invalid API response structure');
                        }
                    }).catch(function (error) {
                        console.error('❌ getCartData REJECTED with error:', error);
                        // Delete checkout cookie on error
                        StorageUtils.deleteCookie('checkout');
                        console.log('✅ Checkout cookie deleted due to API error');
                    });
                }
                else {
                    console.log('scanProductsRes==>', productListRes);
                    console.log(cartKey, '==>', StorageUtils.getCookie(cartKey));
                    // Check if cart is already populated in Redux store (from initCart restore)
                    const currentState = nvstore.getState();
                    if (currentState.cart && currentState.cart.length > 0) {
                        // Cart already restored in initCart, don't overwrite it
                        console.log('✅ Cart already restored, skipping ProductModule.setProducts restore');
                        if (initialCartState && initialCartState.length) {
                            uniqueCategories = [...new Set(initialCartState.map(item => item.category))];
                        }
                        if (uniqueCategories && uniqueCategories.length) {
                            activeTab = uniqueCategories.length === 1 ? uniqueCategories[0] : 'nvidia';
                        }
                    } else if (StorageUtils.getCookie(cartKey)) {
                        // Only restore if cart is empty (fallback case)
                        if (initialCartState && initialCartState.length) {
                            uniqueCategories = [...new Set(initialCartState.map(item => item.category))];
                        }
                        if (uniqueCategories && uniqueCategories.length) {
                            activeTab = uniqueCategories.length === 1 ? uniqueCategories[0] : 'nvidia';
                        }
                        console.log('initialCartState', initialCartState);
                        nvstore.dispatch({
                            type: actionTypes.SET_CART,
                            cart: initialCartState,
                            lastAction: null
                        });
                    } else {
                        nvstore.dispatch({
                            type: actionTypes.SET_CART,
                            cart: [],
                            lastAction: null
                        });
                    }
                }
            }).catch(function (error) {
                // Handle the case when scanProducts fails
                console.error('❌ scanProducts REJECTED with error:', error);
                // Check if cart is already populated in Redux store (from initCart restore)
                const currentState = nvstore.getState();
                if (currentState.cart && currentState.cart.length > 0) {
                    // Cart already restored in initCart, don't overwrite it
                    console.log('✅ Cart already restored, skipping ProductModule.setProducts restore on error');
                } else if (StorageUtils.getCookie(cartKey)) {
                    if (initialCartState && initialCartState.length) {
                        uniqueCategories = [...new Set(initialCartState.map(item => item.category))];
                    }
                    if (uniqueCategories && uniqueCategories.length) {
                        activeTab = uniqueCategories.length === 1 ? uniqueCategories[0] : 'nvidia';
                    }
                    console.log('initialCartState', initialCartState);
                    nvstore.dispatch({
                        type: actionTypes.SET_CART,
                        cart: initialCartState,
                        lastAction: null
                    });
                } else {
                    nvstore.dispatch({
                        type: actionTypes.SET_CART,
                        cart: [],
                        lastAction: null
                    });
                }
            });
        } else {
            var productIdsInCart = []; // we have no cart info
        }
    }
};